import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { OAuthActions } from '../../config/Authentication';
import {
    modalPropertyHelpActions,
    modalPropertyActions,
    modalThemeAndConfigHelpActions,
    modalThemeAndConfigActions,
    modalSaveActions
} from '../modals/AllModal';
import { envValue } from '../../../config/envUtils';
import UnsavedChangesModal from '../modals/UnsavedChangesModal';
import ViewSiteButton from '../common/ViewSiteButton';
import { HELP_FILE_ROUTES_MAP, HELP_ROUTES, SEPARATE_HELP_ROUTES } from '../../constants/HelpFile'
import { last, split } from 'lodash';

const HELP_URL = envValue('HELP_URL');

class Header extends Component {
    constructor(props) {
        super(props);
        this.state = {
            buttonAction: '',
            displaySaveConfirmationModal: false
        };
    }

    signOut = () => {
        const { signOut } = this.props;
        signOut();
    };

    openSaveDialog = () => {
        const { modalSave } = this.props;
        modalSave.show();
    };

    continueAction = () => {
        const { buttonAction } = this.state;

        if (buttonAction === 'hotelAndChain') {
            this.showPropertyModal();
        } else {
            this.showThemeAndConfigModal();
        }
    };

    onClickPropertyIcon = () => {
        const { hasUnsavedChanges } = this.props;

        if (hasUnsavedChanges) {
            this.setState({
                displaySaveConfirmationModal: true,
                buttonAction: 'hotelAndChain'
            });
        } else {
            this.showPropertyModal();
        }
    };

    onClickConfigThemeButton = () => {
        const { hasUnsavedChanges } = this.props;

        if (hasUnsavedChanges) {
            this.setState({
                displaySaveConfirmationModal: true,
                buttonAction: 'configsAndThemes'
            });
        } else {
            this.showThemeAndConfigModal();
        }
    };

    showThemeAndConfigModal = () => {
        const { modalThemeAndConfig } = this.props;
        this.resetModalState();
        modalThemeAndConfig.show();
    };

    showPropertyModal = () => {
        const { modalSelectProperty } = this.props;
        this.resetModalState();
        modalSelectProperty.show();
    };

    resetModalState = () => {
        this.setState({
            displaySaveConfirmationModal: false,
            buttonAction: ''
        });
    };

    onClickHelpButton = () => {
        const { location } = this.props;
        const route = last(split(location, '/'));
        const isSeparateRoute = SEPARATE_HELP_ROUTES.includes(route);
        const isSpecificHelpRouteType = !!HELP_ROUTES[route]

        if (!isSeparateRoute && !isSpecificHelpRouteType) {
            return window.open(`${HELP_URL}/help/index.htm#t=home.htm`);
        }

        const helpFileRoute = HELP_FILE_ROUTES_MAP[location.split(`/${route}`).join('')];
        const helpUrl = isSeparateRoute
            ? `${HELP_URL}/help/index.htm#t=${HELP_FILE_ROUTES_MAP[location]}.htm`
            : `${HELP_URL}/help/index.htm#t=${helpFileRoute}${HELP_ROUTES[route]}.htm`;

        window.open(helpUrl);
    };

    render() {
        const { property, theme, config, hasUnsavedChanges, level, chain, hotel, username, isThemeSbem } = this.props;
        const { displaySaveConfirmationModal } = this.state;
        const disableSaveButton = hasUnsavedChanges ? '' : { disabled: 'disabled' };

        return (
            <header className="spark-header">
                <nav className="spark-header__nav" role="navigation">
                    <span className="spark-header__logo" style={{ height: '85px', top: '5px' }}>
                        <img
                            src="/public/images/aven-logo.png"
                            style={{ height: 70, padding: '0 .5rem' }}
                            alt="Synxis Booking Engine"
                        />
                    </span>
                    <div className="spark-center-block" style={{ padding: '20px 0', width: 'auto' }}>
                        <div>
                            <span className="spark-bold">Property: </span>
                            <span>{property}</span>
                            <span style={{ paddingLeft: 10 }}>
                                <button
                                    onClick={this.onClickPropertyIcon}
                                    className="spark-btn--icon spark-icon spark-icon-pencil spark-icon--fill header-icon small"
                                    title="Select Chain and Hotel"
                                    type="button"
                                />
                            </span>
                        </div>
                        <div>
                            <span className="spark-bold">{isThemeSbem ? 'In-context theme: ' : 'Theme: '}</span>
                            <span>{`(${theme})`}</span> + <span className="spark-bold">Config: </span>
                            <span>{config}</span>
                            <span style={{ paddingLeft: 10 }}>
                                <button
                                    onClick={this.onClickConfigThemeButton}
                                    className="spark-btn--icon spark-icon spark-icon-pencil spark-icon--fill header-icon small"
                                    title="Select Theme and Config"
                                    type="button"
                                />
                            </span>
                        </div>
                    </div>

                    <div className="" style={{ padding: '2rem 1rem', display: 'flex', justifyContent: 'flex-end' }}>
                        <div
                            style={{ display: 'inline-block', margin: '0 5px' }}
                            id="header-menu-preview-container"
                            className="align-middle pull-right"
                        >
                            <ViewSiteButton size="sm" />
                        </div>
                        <div
                            style={{ display: 'inline-block', margin: '0 5px' }}
                            id="header-menu-save-container"
                            className="align-middle pull-right"
                        >
                            <button
                                className="spark-btn spark-btn--sm"
                                onClick={this.openSaveDialog}
                                type="button"
                                {...disableSaveButton}
                            >
                                Save
                            </button>
                        </div>
                        <div
                            style={{ display: 'flex', alignItems: 'center', margin: '0 15px' }}
                            id="header-menu-save-container"
                            className="align-middle pull-right"
                        >
                            <h5 style={{ margin: 0, color: '#000000' }}>{username}</h5>
                        </div>
                        <button
                            onClick={this.onClickHelpButton}
                            className="spark-btn--icon spark-icon spark-icon-question-mark-circle spark-icon--fill header-icon"
                            title="Help"
                            type="button"
                        />
                        <button
                            onClick={this.signOut}
                            className="spark-btn--icon spark-icon spark-icon-sign-out spark-icon--fill header-icon"
                            title="Sign Out"
                            type="button"
                        />
                    </div>
                </nav>
                {displaySaveConfirmationModal && (
                    <UnsavedChangesModal
                        level={level}
                        chain={chain}
                        hotel={hotel}
                        onClose={this.resetModalState}
                        onPrimaryClick={this.continueAction}
                        onSecondaryClick={this.resetModalState}
                    />
                )}
            </header>
        );
    }
}

Header.propTypes = {
    chain: PropTypes.string.isRequired,
    config: PropTypes.string.isRequired,
    hasUnsavedChanges: PropTypes.bool.isRequired,
    hotel: PropTypes.string.isRequired,
    level: PropTypes.string.isRequired,
    signOut: PropTypes.func.isRequired,
    username: PropTypes.string.isRequired,
    modalSelectPropertyHelp: PropTypes.shape({
        show: PropTypes.func
    }).isRequired,
    modalSelectProperty: PropTypes.shape({
        show: PropTypes.func
    }).isRequired,
    modalThemeAndConfigHelp: PropTypes.shape({
        show: PropTypes.func
    }).isRequired,
    modalThemeAndConfig: PropTypes.shape({
        show: PropTypes.func
    }).isRequired,
    modalSave: PropTypes.shape({
        show: PropTypes.func
    }).isRequired
};

const mapDispatchToProps = dispatch => ({
    signOut: () => dispatch(OAuthActions.signout()),
    modalSelectPropertyHelp: {
        show: () => dispatch(modalPropertyHelpActions.show())
    },
    modalSelectProperty: {
        show: () => dispatch(modalPropertyActions.show())
    },
    modalThemeAndConfigHelp: {
        show: () => dispatch(modalThemeAndConfigHelpActions.show())
    },
    modalThemeAndConfig: {
        show: () => dispatch(modalThemeAndConfigActions.show())
    },
    modalSave: {
        show: () => dispatch(modalSaveActions.show())
    }
});

const mapStateToProps = state => {
    return {
        chain: state.app.selected.chain.Id,
        changed: state.save.changed,
        hasUnsavedChanges:
            state.save.configChange ||
            state.save.themeChange ||
            state.app.data.labels.labels.changed ||
            state.app.data.thirdparty.changedManageApps ||
            state.app.selected.themeFileChanged ||
            state.app.data.configuration.configuration.configFileChanged,
        hotel: state.app.selected.selectedHotel.id,
        hotelList: state.manage.hotelList,
        level: state.app.selected.level,
        username: state.oauth.username,
        isThemeSbem: state.app.selected.isThemeSbem
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);



// WEBPACK FOOTER //
// ./src/components/layout/Header.js